export default "__VITE_ASSET__Gq6MMLXP__"